import FormOneliner from '@@client/components/FormOneliner'

function dateToDateString(date) {
    if(!date) {
        return ''
    }

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

function dateStringToDate(dateStr) {
    if(!dateStr) {
        return null
    }

    const dateUtc = new Date(dateStr)
    // convert the date to the user's local timezone
    const timezoneOffset = dateUtc.getTimezoneOffset()

    const dateLocal = new Date(dateUtc.getTime() - timezoneOffset * 60000)
    // zero out the time portion of the date, in the user's local timezone
    dateLocal.setHours(0, 0, 0, 0)

    return dateLocal
}

export default function FormPhone({onChange, value, ...formOnelinerAtts}) {
    const handleChange = (e) => {
        const value = (e && e.target) ? e.target.value : e

        onChange(dateStringToDate(value))
    }

    // this will get the data in "YYYY-MM-DD" format
    const valueStr = dateToDateString(value)

    return <FormOneliner type='date' onChange={handleChange} value={valueStr} {...formOnelinerAtts} />
}
